import { render, staticRenderFns } from "./LedgerAccounts.vue?vue&type=template&id=256561fe&scoped=true&lang=pug&"
import script from "./LedgerAccounts.vue?vue&type=script&lang=js&"
export * from "./LedgerAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256561fe",
  null
  
)

export default component.exports